<template>
  <v-dialog :value="open" :width="400" persistent>
    <v-card>
      <v-card-title primary-title class="headline primary--text">{{
        $t('change password')
      }}</v-card-title>
      <v-card-text>
        <form id="passwordChangeForm" @submit="handleSubmit">
          <v-container fluid grid-list-lg class="pa-0 ma-0" :style="{ width: '100% !important' }">
            <v-layout wrap>
              <v-flex xs12 class="form-control" :class="{ 'has-error': errors.has('password') }">
                <label class="caption">{{ $t('New password') }}</label>
                <input
                  ref="password"
                  v-model="form.password"
                  v-validate="'required'"
                  name="password"
                  type="password"
                  :disabled="isLoading"
                  :data-vv-as="$t('New password')"
                />
                <p v-if="errors.has('password')" class="text-error ma-0">
                  {{ errors.first('password') }}
                </p>
              </v-flex>
              <v-flex
                xs12
                class="form-control"
                :class="{ 'has-error': errors.has('confirm_password') }"
              >
                <label class="caption">{{ $t('Confirm password') }}</label>
                <input
                  v-model="form.confirm_password"
                  v-validate="'required|confirmed:password'"
                  name="confirm_password"
                  type="password"
                  :disabled="isLoading"
                  :data-vv-as="$t('Confirm password')"
                />
                <p v-if="errors.has('confirm_password')" class="text-error ma-0">
                  {{ errors.first('confirm_password') }}
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions :style="{ justifyContent: 'center' }">
        <v-btn outline color="grey" :disabled="isLoading" @click="$emit('update:open', false)">{{
          $t('cancel')
        }}</v-btn>
        <v-btn color="primary" :loading="isLoading" type="submit" form="passwordChangeForm">{{
          $t('Confirm')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import tigerpolyApi from '@/api/tigerpoly'

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        password: '',
        confirm_password: ''
      },
      isLoading: false
    }
  },
  watch: {
    open(value) {
      if (value) {
        this.form = {
          password: '',
          confirm_password: ''
        }
        this.isLoading = false
        this.$validator.reset()
      }
    }
  },
  methods: {
    async handleSubmit(event) {
      event.preventDefault()

      const isValid = await this.$validator.validate()

      if (!this.value || !isValid) return

      try {
        this.isLoading = true

        const response = await tigerpolyApi.putMember({
          data: {
            id: this.value.id,
            page_id: this.value.page_id,
            password: this.form.password
          }
        })

        if (response.status === 204) {
          this.$emit('success')
        }
      } catch (error) {
        this.isLoading = false

        if (error.response.data) {
          this.$swal.fire(error.response.data.message, undefined, 'error')
        }
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/member/PasswordChangeDialog.vue